// MINDSET BRAND — www.mindsetbrand.shop
function toggleNav() { var nav = document.getElementById('mobileNav'); if (nav) nav.classList.toggle('open'); }
document.addEventListener('click', function(e) {
  var nav = document.getElementById('mobileNav'); var toggle = document.querySelector('.nav-toggle');
  if (nav && toggle && !nav.contains(e.target) && !toggle.contains(e.target)) { nav.classList.remove('open'); }
});
var obs = new IntersectionObserver(function(entries) {
  entries.forEach(function(e) { if (e.isIntersecting) { e.target.style.opacity='1'; e.target.style.transform='translateY(0)'; obs.unobserve(e.target); } });
}, {threshold:0.08});
document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.msf-product-card,.msf-value-card,.msf-transform-photo,.msf-design-card').forEach(function(el) {
    el.style.opacity='0'; el.style.transform='translateY(16px)'; el.style.transition='opacity 0.5s ease,transform 0.5s ease'; obs.observe(el);
  });
});
